import * as React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Box } from '@chakra-ui/react';
import filterTypes from '../../utitlities/filterTypes';

function AllProductSubcategories(props) {
  const { Item, category } = props;

  /* QUERY */
  const data = useStaticQuery(graphql`
    query {
      allSanityProductSubCategory {
        nodes {
          name
          slug {
            current
          }
          category {
            name
            slug {
              current
            }
          }
        }
      }
    }
  `);

  const wanaSubcategories = data.allSanityProductSubCategory.nodes;
  
  return (
    <Box>
      {wanaSubcategories.map((item, indx) => {
        if (item.category.slug.current === category) {
          return (
            <Item key={indx} filterType={filterTypes.SUBCATEGORY} item={item} />
          );
        }
      })}
    </Box>
  );
}

export default AllProductSubcategories;
